module.exports = __webpack_public_path__ + "img/DE03692.ed53baea.png";